<template>
  <div id="marathon_signupIndex" v-show="currThemeObj">
    <div class="select_area">
      <marathon_select_opt
        :currThemeObj="currThemeObj"
        :data="selectOptData"
        :inputObject="select_opt_inputObject"
        @changeSelectEvent="changeSelect"
        @inputValEvent="inputValHandler"
      ></marathon_select_opt>
    </div>
    <div class="teamTable">
      <div class="tableScrollArea" ref="tableParentDom">
        <nodeTree_table
          :currThemeObj="currThemeObj"
          :currCid="currCid"
          :currSid="currSid"
          :tableMode="tableMode"
          :parentWidthPx="parentWidthPx"
          :isScrollFlag="isScrollFlag"
          :variableColWidthVw="variableColWidthVw"
          :tableCellDefaultWidthVw="tableCellDefaultWidthVw"
          :defaultWidthVwNum="defaultWidthVwNum"
          :tableColumnData="tableColumnData"
          :tableData="tableData"
          :tableHeightPx="tableHeightPx"
          @clickColumnEvent="clickColumn"
          v-show="tableData && tableData.length > 0"
        ></nodeTree_table>
        <p class="loadingClass" v-show="loading">加载中...</p>
        <p class="noMoreClass" v-show="noMore">没有更多了</p>
        <p class="noDataClass" v-show="noData">暂无数据</p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  https_marathon_palyerSignup,
  https_marathon_genderCode,
  https_marathon_stageteammenu,
} from '@api/platfrom_marathon_api'
import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'

// 表格中不需要跳转页面
import nodeTree_table from '@components/platfromBase/marathon/nodeTree_table.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'marathon_signupIndex',
  components: {
    marathon_select_opt,
    nodeTree_table,
  },
  mixins: [cup_base_data_mixin],
  data() {
    return {
      select_opt_inputObject: {
        inputTitle: '快速查询',
        placeholder: '请输入运动员名称',
        iconType: 'search',
      }, //控制marathon_select_opt中的输入框是否显示
      isScrollBottom: false,
      loading: false,
      tableMode: 'playerData',
      parentWidthPx: 0,
      parentHeightPx: 0,
      isScrollFlag: true,
      isClickFlag: false,
      variableColWidthVw: 16.67,
      tableCellDefaultWidthVw: 4.16,
      defaultWidthVwNum: null,
      tableColumnData: [],
      tableData: null,
      tableTotal: 0,
      currStageMarathon: '',
      curInputVal: '',
      pnum: 1,
      psize: 20,
      marathonTypeArr: [],
      sexArr: [],
      actArr: [],
      selectOptData: {
        configArr: [
          {
            type: 'marathonType',
            title: '赛事类型',
            origin_keyVal: ['value', 'name'],
            dataName: 'marathonTypeArr',
          },
          {
            type: 'sex',
            title: '性别',
            origin_keyVal: ['value', 'name'],
            dataName: 'sexArr',
          },
        ],
        selectOpt_list: [],
      },
    }
  },
  beforeCreate() {},
  created() {
    // this.parentHeightPx = this.$refs.tableParentDom.offsetHeight
    this.init()
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  computed: {
    noMore() {
      const curTableDataNum = this.tableData ? this.tableData.length : -1
      return (
        curTableDataNum >= this.tableTotal &&
        this.tableTotal !== 0 &&
        this.isScrollBottom
      )
    },
    noData() {
      return (
        this.tableTotal === 0 && this.tableData && this.tableData.length === 0
      )
    },
    tableHeightPx() {
      let clientHeight = window.innerHeight
        ? window.innerHeight
        : window.screen.height
        ? window.screen.height
        : 667
      let clientWidth = window.innerWidth
        ? window.innerWidth
        : window.screen.width
        ? window.screen.width
        : 375

      return Math.floor(clientHeight - (clientWidth / 100) * (42 - 26))
      // return 500
    },
  },
  methods: {
    inputValHandler(inputVal) {
      // 获取inputVal值
      console.debug('inputVal:', inputVal)
      this.curInputVal = inputVal
      this.initTableQuery()
      this.getRecordPlayerStat()
    },
    initScroll() {
      if (this.tableDom) {
        return
      }
      this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      console.debug(
        'this.parentWidthPx:',
        this.$refs.tableParentDom.scrollHeight
      )
      this.beforeScrollTop = 0
      this.threshold = 5
      this.DIRECTION_ENUM = {
        DOWN: 'down',
        UP: 'up',
      }
      window.addEventListener('resize', () => {
        this.onResizeEvent()
      })
      this.tableDom = document.getElementsByClassName(
        'el-table__body-wrapper'
      )[0]
      this.tableDom.addEventListener('scroll', () => {
        const scrollTop = this.tableDom.scrollTop
        const scrollHeight = this.tableDom.scrollHeight
        const parentHeightPx = this.tableDom.offsetHeight
        let direction = this.DIRECTION_ENUM.DOWN
        if (this.beforeScrollTop > scrollTop) {
          direction = this.DIRECTION_ENUM.UP
        }
        // 通过滚动方向判断是触底还是触顶
        console.debug(
          'direction:',
          direction,
          scrollTop,
          parentHeightPx,
          scrollHeight,
          this.isScrollBottom
        )
        if (direction == this.DIRECTION_ENUM.DOWN) {
          // 滚动触底
          if (scrollTop + parentHeightPx + this.threshold >= scrollHeight) {
            console.debug('滚动触底')
            this.load()
            if (this.pnum > this.allPages) {
              this.isScrollBottom = true
            }
          }
        } else {
          // 滚动到顶部
          this.isScrollBottom = false
          if (scrollTop <= this.threshold) {
            console.debug('滚动到顶部')
          }
        }
        this.beforeScrollTop = this.tableDom.scrollTop
      })
    },
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      this.initTableQuery()
      console.debug(this.currCid, this.currSid)
      await this.getstageMarathon()
      await this.getGenderCode()
      await this.getRecordPlayerStat()
      console.debug(this.stageArr)
      this.computedSelectOpt(this.selectOptData.configArr)

      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    onResizeEvent() {
      if (this.$refs.tableParentDom) {
        this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      } else {
        console.debug('dom 不存在')
      }
    },
    computedSelectOpt(configArr) {
      // 组装选择框数据
      let selectOpt_list = []
      configArr.forEach((config, index) => {
        let disabledArr = []
        const mix_id = `mix_${config.origin_keyVal[0]}`
        console.debug(config.dataName, this[config.dataName])
        let list = this[config.dataName].map((item) => {
          item[mix_id] = `${config.type}_${item[config.origin_keyVal[0]]}`
          return item
        })
        selectOpt_list.push({
          type: config.type,
          title: config.title,
          keyVal: [mix_id, config.origin_keyVal[1]],
          curId: list[0][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
          curVal: list[0][config.origin_keyVal[1]], // 这个值是源数据需要展示的值，没有做过修改
          disabledArr, //当【阶段】选择为淘汰赛时，球队这栏置灰；所以在【球队】这组对象的disabledArr=['stage_2']；而【阶段】的disabledArr = []。在marathon_select_opt组件中也需要做一些逻辑处理，主要是对curStageVal这个值
          list,
        })
      })

      this.selectOptData.selectOpt_list = selectOpt_list
      console.debug('this.selectOptData.selectOpt_list', selectOpt_list)
    },
    changeSelect(data) {
      console.debug(data)
      let valPathArr = []
      let val = data.val
      // 选择后，重置联动的筛选框
      // let updateSelectIndex = -1
      if (data.type === 'select') {
        if (val.indexOf('_') > -1) {
          valPathArr = val.split('_')
          for (let i = 0; i < this.selectOptData.selectOpt_list.length; i++) {
            let item = this.selectOptData.selectOpt_list[i]
            const idKey = item.keyVal[0]
            const valKey = item.keyVal[1]
            if (item.type == valPathArr[0]) {
              for (let j = 0; j < item.list.length; j++) {
                let cell = item.list[j]
                console.debug(idKey, val)
                if (cell[idKey] == val) {
                  console.debug(cell[idKey], val)
                  // updateSelectIndex = i
                  item.curVal = cell[valKey]
                  break
                }
              }
            }
          }
          if (valPathArr[0] === 'marathonType') {
            this.currStageMarathon = valPathArr[1]
          } else if (valPathArr[0] === 'sex') {
            this.currSex = valPathArr[1]
          } else {
          }
          // 筛选表格逻辑
          this.initTableQuery()
          this.tableColumnData = []
          this.getRecordPlayerStat()
        } else {
          console.debug('id命名方式不符合组件规则')
        }
      } else {
        console.debug('data.type 没有匹配成功')
      }
    },
    load() {
      console.debug('load')
      if (this.pnum > this.allPages || this.loading) {
        return
      }
      this.loading = true
      this.getRecordPlayerStat()
    },
    clickColumn(prop) {
      console.debug(prop)
      this.initTableQuery()
      this.getRecordPlayerStat()
    },
    initTableQuery() {
      this.pnum = 1
    },
    async getstageMarathon() {
      await https_marathon_stageteammenu(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
        cid: this.currCid,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.marathonTypeArr = res.data ? res.data : []
            this.currStageMarathon = res.data[0] ? res.data[0].value : ''
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getGenderCode() {
      await https_marathon_genderCode(this.axiosBaseUrl, this.$axios)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.sexArr = res.data ? res.data : []
            if (this.sexArr.length > 0) {
              this.currSex = this.sexArr[0].value
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getRecordPlayerStat() {
      await https_marathon_palyerSignup(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
        pcode: this.currStageMarathon ? this.currStageMarathon : '',
        gcode: this.currSex ? this.currSex : '',
        aname: this.curInputVal,
        pnum: this.pnum,
        psize: this.psize,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            if (res.data) {
              this.tableTotal = res.data.total
              this.allPages = res.data.pages
              const columns = [
                {
                  colKey: 'rankNum',
                  colTitle: '排名',
                },
                {
                  colKey: 'athleteName',
                  colTitle: '球员名称',
                },
                {
                  colKey: 'playerLogo',
                  colTitle: '球员头像',
                },
                {
                  colKey: 'athleteNum',
                  colTitle: '号码',
                },
                {
                  colKey: 'birthDate',
                  colTitle: '生日',
                },
                {
                  colKey: 'residenceProvince',
                  colTitle: '居住地(省)',
                },
                {
                  colKey: 'residenceCity',
                  colTitle: '居住地(市)',
                },
                {
                  colKey: 'profession',
                  colTitle: '职业',
                },
                {
                  colKey: 'education',
                  colTitle: '教育程度',
                },
                {
                  colKey: 'phoneNumber',
                  colTitle: '手机号码',
                },
              ]
              const fristColumns = columns.slice(0, 4)
              const otherColumns = columns.slice(4)
              this.defaultWidthVwNum = otherColumns.length
              if (this.tableColumnData.length == 0) {
                let tableColumnData = []
                let fristColumnPropArr = []
                for (let i = 0; i < fristColumns.length; i++) {
                  fristColumnPropArr.push(fristColumns[i].colKey)
                }
                const fristColumn = {
                  prop: 'rankNum-playerLogo-playerName-shirtNumber-sex', //fristColumnPropArr.join('-'),
                  label: '运动员',
                  widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
                  className: 'columnNumLogoNameClass', //单独定制的头部样式class
                  // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
                }

                tableColumnData.push(fristColumn)
                for (let i = 0; i < otherColumns.length; i++) {
                  const item = otherColumns[i]
                  tableColumnData.push({
                    prop: item.colKey,
                    label: item.colTitle,
                    widthVw:
                      item.colKey != 'teamLogo-teamName'
                        ? this.tableCellDefaultWidthVw
                        : 20, //对应列的宽度，单位vw
                    className:
                      item.colKey != 'teamLogo-teamName'
                        ? ''
                        : 'columnLogoNameClass', //单独定制的头部样式class
                    selected: '',
                  })
                }
                // console.debug('res.data：',res.data)
                this.tableColumnData = tableColumnData
              }
              if (this.pnum == 1) {
                let indexNo = 0
                this.tableData = res.data.list
                  ? res.data.list.map((val) => {
                      this.actArr.forEach((item) => {
                        if (item.code == val.isActive) {
                          val.isActiveName = item.name
                        }
                      })
                      indexNo++
                      val.rankNum = indexNo
                      return val
                    })
                  : []
                // this.$refs.tableParentDom.scrollTo(0, 0)
                this.initScroll()
              } else {
                let indexNo =
                  this.tableData && this.tableData.length > 0
                    ? this.tableData.length
                    : 0
                this.tableData = this.tableData.concat(
                  res.data
                    ? res.data.list.map((val) => {
                        this.actArr.forEach((item) => {
                          if (item.code == val.isActive) {
                            val.isActiveName = item.name
                          }
                        })
                        indexNo++
                        val.rankNum = indexNo
                        return val
                      })
                    : []
                )
              }
            } else {
              console.debug('暂无数据')
            }
            console.debug(
              '暂无数据:',
              this.tableTotal,
              this.tableData,
              this.tableData.length
            )
            if (this.tableTotal >= this.tableData.length) {
              if (this.tableTotal === 0) {
                this.tableData = []
              } else {
                if (this.pnum !== 1) {
                  this.$nextTick(() => {
                    this.loading = false
                  })
                } else {
                  this.$nextTick(() => {
                    this.loading = false
                    if (
                      this.$refs.tableParentDom.offsetHeight <
                      Math.floor(this.tableHeightPx)
                    ) {
                      this.isScrollBottom = true
                    }
                    console.debug(
                      'getParentHeightPx:',
                      this.$refs.tableParentDom.offsetHeight,
                      this.tableHeightPx
                    )
                  })
                }
                this.pnum++
              }
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#marathon_signupIndex {
  .select_area {
    position: relative;
    padding-top: 2.778vw;
    width: 100%;
    height: 9.028vw;
    .switch_area {
      position: absolute;
      top: 2.778vw;
      right: 0;
      z-index: 10;
    }
  }

  .teamTable {
    padding: 2.778vw 0 6.964vw;
    .tableScrollArea {
      position: relative;
    }
  }

  .loadingClass,
  .noMoreClass,
  .noDataClass {
    position: absolute;
    bottom: -4.166vw;
    left: 0;
    z-index: 2;
    width: 100%;
    line-height: 4.166vw;
    text-align: center;
    font-size: 0.972vw;
    color: var(--mixtmt_greyColor2);
  }
  .noDataClass {
    border-top: 1px solid var(--mixtmt_greyColor0);
    border-bottom: 1px solid var(--mixtmt_greyColor0);
  }
}
</style>
